import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import { isWechat } from "@/util/wechat";
import { weChatAuth } from "@/util/wxAuth.js";
import { Toast } from "vant";
Vue.use(VueRouter);
const router = new VueRouter({
  base: "/",
  mode: "history",
  routes,
});
router.beforeEach(async (to, from, next) => {
  const whiteList = [
    "/legal-agreement/gm/terms/user-agreement",
    "/legal-agreement/gm/terms/privacy-agreement",
    "/legal-agreement/gm/terms/service-agreement",
    "/gm/introduction/platformIntroduction",
    "/gm/introduction/law",
    "/gm/introduction/enterprises",
    "/gm/introduction/merchants",
    "/app",
    "/device",
    "/idCode",
    "/productDetail",
    "/exportLogisticsPDF",
    "/market",
    "/kLine",
    "/pd",
    "/p",
    "/appreciate",
    "/appreciate/login",
    "/appreciate/agreement",
    "/article",
  ];
  const ischat = isWechat();
  if (ischat) {
    let code = window.localStorage.getItem("code") || to.query.code;
    let token = window.localStorage.getItem("token");
    console.info("to.path", to.path);
    if (whiteList.indexOf(to.path) !== -1) {
      next();
      return;
    }
    let matched = whiteList.find((link) => {
      return to.path.startsWith(link);
    });
    if (matched) {
      next();
      return;
    }
    if (token) {
      next();
    } else if (!code || code === "undefined") {
      next();
      // window.sessionStorage.setItem("curPageUrl", window.location.href);
      // weChatAuth();
    } else {
      next();
    }
  }
  if (!ischat && whiteList.indexOf(to.path) === -1) {
    if (routes.includes(to.path)) {
      Toast("请在微信中打开");
    } else {
      next();
    }
  } else {
    next();
  }
});
export default router;
